import { initCookieConsent } from "@puregym/cookieconsent";
import { updateAppElement } from "@puregym/ui";
import { GatsbyBrowser } from "gatsby";
import App from "./src/app";
import { COOKIE_CONSENT_INITIALISED_EVENT_NAME } from "./src/utilities/useCookieConsent";

export const wrapPageElement = ({ element, props }) => (
  <App {...props}>{element}</App>
);

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  updateAppElement("#___gatsby");

  if (process.env.GATSBY_TEST_MODE) {
    window["dataLayer"] = [];
  }
};

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] =
  () => {
    const activeLang = (locale) => {
      switch (locale) {
        case "ar-SA":
          return "AR";
        case "ar-AE":
          return "AR";
        default:
          return "EN";
      }
    };

    updateAppElement("#___gatsby");
    process.env.GATSBY_BRAND === "PGUK" && initCookieConsent("EN");
    (process.env.GATSBY_BRAND === "PGSA" ||
      process.env.GATSBY_BRAND === "UAE") &&
      initCookieConsent(`${activeLang(process.env.GATSBY_LOCALE)}`);
    window.dispatchEvent(new Event(COOKIE_CONSENT_INITIALISED_EVENT_NAME));
  };
